export default __webpack_public_path__ + "882af89f94a1805e279ed48fbcf71f77.png";